import { EditorialMarkdownBlock } from "../../lib/storyblok/types/blocks/EditorialMarkdownBlock";
import { StoryblokBlockComponent } from "../../lib/storyblok/types/StoryblokComponent";
import Editorial from "../../ui/Editorial/Editorial";
import Markdown from "../../ui/Markdown";
import RichText from "../../ui/Common/RichText";
import { isRichTextContent } from "../../lib/storyblok/types/fieldtypes/richText";

const EditorialImage: StoryblokBlockComponent<EditorialMarkdownBlock> = ({
  markdown,
}) => {
  return (
    <Editorial.Copy>
      {isRichTextContent(markdown) ? (
        <RichText content={markdown} alignment={"alignLeft"} inverted={false} />
      ) : (
        <Markdown>{markdown}</Markdown>
      )}
    </Editorial.Copy>
  );
};

export default EditorialImage;
